// Picture swap in the Wochenplan (delivery-automation PLAN.md 32g): which posts may be swapped at all. Shared by the
// server (dfyMediaSwap.ts, authoritative) and the Wochenplan (shows the swap only where the server allows it).
import { isSignalRoomSourced } from "./signalRoom.js";

/** May this post's pictures be swapped at all? SR posts only with one overlay per picture. Pure. */
export function swapBlockedReason(post: { sourceRef?: string | null; imageUrl?: string | null; imageUrls?: unknown; imageOverlayUrls?: unknown }): string | null {
  const count = Array.isArray(post.imageUrls) && post.imageUrls.length > 1 ? post.imageUrls.length : (post.imageUrl ? 1 : 0);
  if (count === 0) return "Dieser Beitrag hat kein Bild zum Tauschen.";
  if (isSignalRoomSourced(post.sourceRef) && !(Array.isArray(post.imageOverlayUrls) && post.imageOverlayUrls.length === count)) {
    return "Bei diesem Beitrag ist der Bildtausch noch nicht möglich, weil sonst der Text auf dem Bild verloren ginge.";
  }
  return null;
}
